import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/team',
    name: 'Team',
    component:()=> import("../views/Team.vue")
  },
  {
    path: '/team/:name',
    name: 'Details',
    component:()=> import("../views/Details.vue")
  },
  {
    path: '/about',
    name: 'About',
    component:()=> import("../views/About.vue")
  },
  {
    path: '/consulting',
    name: 'Consulting',
    component:()=> import("../views/services/Consulting.vue")
  },
  {
    path: '/IT_NetworkServices',
    name: 'IT_NetworkServices',
    component:()=> import("../views/services/IT_NetworkServices.vue")
  }
  ,
  {
    path: '/managed-services',
    name: 'ManagedServices',
    component:()=> import("../views/services/ManagedServices.vue")
  }
  ,
  {
    path: '/business-pulse-analytics',
    name: 'BusinessPulseAnalytics',
    component:()=> import("../views/services/BusinessPulseAnalytics.vue")
  }
  ,
  {
    path: '/custom-applications',
    name: 'CustomApplications',
    component:()=> import("../views/services/CustomApplications.vue")
  }
  ,
  {
    path: '/document-mangment-assembely',
    name: 'DocumentMangmentAssembely',
    component:()=> import("../views/Software/DocumentMangmentAssembely.vue")
  },
  {
    path: '/Time_Billing_And_Accounting',
    name: 'Time_Billing_And_Accounting',
    component:()=> import("../views/Software/Time_Billing_And_Accounting.vue")
  },
  {
    path: '/Practice_Management_And_CRM',
    name: 'Practice_Management_And_CRM',
    component:()=> import("../views/Software/Practice_Management_And_CRM.vue")
  },
  {
    path: '/Specialty_Products',
    name: 'Specialty_Products',
    component:()=> import("../views/Software/Specialty_Products.vue")
  },
  {
    path: '/Cloud_Services',
    name: 'Cloud_Services',
    component:()=> import("../views/Software/Cloud_Services.vue")
  }
  ,
  {
    path: '/Contact',
    name: 'Contact',
    component:()=> import("../views/Contact.vue")
  }
  ,
  {
    path: '/SendAPaymemnt',
    name: 'SendAPaymemnt',
    component:()=> import("../views/clients/SendAPaymemnt.vue")
  }
  ,
  {
    path: '/CaseStudies',
    name: 'CaseStudies',
    component:()=> import("../views/Resources/CaseStudies.vue")
  },
  {
    path: '/Blogs',
    name: 'Blogs',
    component:()=> import("../views/Resources/Blog.vue")
  },
  {
    path: '/HelpingSecureYourSensitiveData',
    name: 'HelpingSecureYourSensitiveData',
    component:()=> import("../views/Resources/HelpingSecureYourSensitiveData.vue")
  },
  {
    path: '/FindingtheMVPofMSPs',
    name: 'FindingtheMVPofMSPs',
    component:()=> import("../views/Resources/FindingtheMVPofMSPs.vue")
  },
  {
    path: '/IsItTimetoKickYourServertotheCurb',
    name: 'IsItTimetoKickYourServertotheCurb',
    component:()=> import("../views/Resources/IsItTimetoKickYourServertotheCurb.vue")
  },
  {
    path: '/Products/:id?',
    name: 'Products',
    component:()=> import("../views/solusions/Products.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
